export default {
  baseURL: 'http://oa.xinyunzhi.com/'

}


// WEBPACK FOOTER //
// ./src/api/requestConfig.js